/** Sweatpants Component */
import t from"react";import m from"styled-components";const r=`
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  word-wrap: normal !important;
`,d=m.span`
  ${r}
`,i=t.forwardRef(function(n,p){const{children:a,as:o="span",id:e}=n;return t.createElement(d,{id:e,as:o,ref:p},a)});i.displayName="ScreenReaderOnly";export{i as ScreenReaderOnly,r as visuallyHidden};
//# sourceMappingURL=index.esm.js.map
